import { render } from "./Positions.vue?vue&type=template&id=3b81b003&scoped=true"
import script from "./Positions.vue?vue&type=script&lang=js"
export * from "./Positions.vue?vue&type=script&lang=js"

import "./Positions.vue?vue&type=style&index=0&id=3b81b003&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b81b003"]])

export default __exports__